import { render, staticRenderFns } from "./SummaryDay.vue?vue&type=template&id=2ae5db5c&"
import script from "./SummaryDay.vue?vue&type=script&lang=js&"
export * from "./SummaryDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports